// breakpoints for screen sizes xs, sm, md, and lg
export const xsMin = '30em';
export const smMin = '48em';
export const mdMin = '64em';
export const lgMin = '75em';
// gutter widths
export const gutterWidth = 16;
export const halfGutterWidth = 8;
export const quarterGutterWidth = 4;
export const doubleGutterWidth = 32;
// media queries for different view widths
export const twoColumnMQ = `only screen and (min-width: ${smMin})`; // smViewport
export const threeColumnMQ = `only screen and (min-width: ${mdMin})`; // mdViewport
export const fourColumnMQ = `only screen and (min-width: ${lgMin})`; // lgViewport
export const SMALL_IMAGE_WIDTH = 300;
export const OVERLAY_ZINDEX = 1200;
export const IOS_STATUS_BAR_HEIGHT = 20;
export const TRANSITION_DURATION = 350;
//# sourceMappingURL=layout.js.map